export default __webpack_public_path__ + "static/media/Fox31TV.389020e5.png";